import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class BCBaseService {

  constructor(private dataService: DataService) { }

  BC_menu_api() {
    return this.dataService.getData('/gmb_listallmenus', true)
  }

  gmb_carddetails(data: any) {
    return this.dataService.post('/gmb/carddetails', data)
  }
  update_cardName(data: any) {
    return this.dataService.post('/gmb/carddetails/update', data)
  }
  get_statement(data: any) {
    return this.dataService.post('/gmb/cardlistroute/statement', data)
  }
  fee_statement(data: any) {
    return this.dataService.post('/gmb/fee_statement', data)
  }
  get_SA_banklist() {
    return this.dataService.getData('/gmb/get_SA_banklist', true)
  }
  search_SA_banklist(data) {
    return this.dataService.getData('/gmb/get_SA_banklist?branch_code=' + data, true)
  }
  otp_send(data) {
    return this.dataService.post('/gmb/add_beneficiaries/otp', data)
  }
  otp_verification(data) {
    return this.dataService.post('/gmb/add_beneficiaries/otp_verification', data)
  }
  add_beneficiary(data) {
    return this.dataService.post('/gmb/add_beneficiary', data)
  }

  get_beneficiary_list(data) {
    return this.dataService.post('/gmb/get_beneficiary_list', data)
  }

  gmb_payment_verification(data) {
    return this.dataService.post('/gmb/gmb_payment_verification', data)
  }

  pay_beneficiary(data) {
    return this.dataService.post('/gmb/pay_beneficiary', data)
  }

  once_off_payment(data) {
    return this.dataService.post('/gmb/once_off_payment', data)
  }

  add_beneficiary_airtime(data) {
    return this.dataService.post('/gmb/add_beneficiary_airtime', data)
  }

  update_beneficiary_airtime(data) {
    return this.dataService.post('/gmb/update_beneficiary_airtime', data)
  }


  get_beneficiary_airtime(data) {
    return this.dataService.post('/gmb/get_beneficiary_airtime', data)
  }

  remove_beneficiary_airtime(data) {
    return this.dataService.post('/gmb/remove_beneficiary_airtime', data)
  }

  delete_beneficiary(data) {
    return this.dataService.post('/gmb/delete_beneficiary', data)
  }

  airtime_purchase_category(data) {
    return this.dataService.post('/gmb/airtime_purchase_category', data)
  }

  get_prepaid_bundle_type(data) {
    return this.dataService.post('/gmb/get_prepaid_bundle_type', data)
  }

  bc_stopCard(data) {
    return this.dataService.post('/gmb/stopCard', data)
  }

  ebuy_airtime(data) {
    return this.dataService.post('/gmb/ebuy_airtime', data)
  }
  purchase_prepaid_bundle_type(data) {
    return this.dataService.post('/gmb/purchase_prepaid_bundle_type', data)
  }
  transaction_history(data) {
    return this.dataService.post('/gmb/transaction_history', data)
  }

}
